import EmployeeModel from "@/components/Forms/Person/models/employeeModel";
import UnionMemberModel from "@/components/Forms/Person/models/unionMemberModel";

class PersonModel {
  name = null;
  surname = null;
  patronymic = null;
  sex = 1;
  email = null;
  phones = [];
  comments = [];
  birthday = null;
  employee_data = null;
  union_member_data = null;
  vip_status = false;
  constructor(personDataRaw) {
    let personData =
      personDataRaw !== undefined
        ? JSON.parse(JSON.stringify(personDataRaw))
        : undefined;
    if (personData !== undefined) {
      let {
        name,
        surname,
        patronymic,
        sex,
        email,
        phones,
        comments,
        birthday,
        employee_data,
        union_member_data,
        vip_status
      } = personData;
      Object.assign(this, {
        name,
        surname,
        patronymic,
        sex,
        email,
        phones,
        comments,
        birthday
      });
      if (employee_data !== null)
        this.employee_data = new EmployeeModel(employee_data);
      if (union_member_data !== null)
        this.union_member_data = new UnionMemberModel(union_member_data);

      if (vip_status !== null) this.vip_status = true;
    }
  }
}

export default PersonModel;
